import React, { useState, useEffect } from 'react';
import "./Help.css";
import HelpPost from './HelpPost';
import HelpSendBox from './HelpSendBox';
import { db } from "../firebase";

function Help({ user }) {
    const [help, setHelp] = useState([]);

    useEffect(() => {
        db.collection("help").orderBy("timestamp", "desc").onSnapshot((snapshot) => {
            setHelp(snapshot.docs.map(doc => ({
                id: doc.id,
                help: doc.data()
            })));
        })
    }, [])

    return (
        <div className="help">
            <h3>Help</h3>
            <HelpSendBox />
            {
                help.map(({id, help}) => [
                    <HelpPost key={id} helpId={id} user={user} displayName={help.displayName} question={help.question} photoURL={help.photoURL} />
                  ])
                }
        </div>
    )
}

export default Help;